class GlassesFinderForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('[type="submit"]');
    }
  
    connectedCallback() {
      this.submitButton.addEventListener('click', e => this.onSubmit(e));
    }
  
    disconnectedCallback() {
      this.submitButton.removeEventListener('click', e => this.onSubmit(e));
    }
  
    onSubmit(e) {
      e.preventDefault(); 
  
  
      const power = this.form['filter.v.option.power'].value.trim();
      const gender = this.form['filter.p.m.custom.gender'].value.trim();
      const url = "/collections/all";
      const queryParams = new URLSearchParams();
  
      if (power) queryParams.append('filter.v.option.power', power);
      if (gender) queryParams.append('filter.p.m.custom.gender', gender);
      queryParams.append('sort_by', 'title-ascending');
  
  
      const formAction = url + (queryParams.toString() ? '?' + queryParams.toString() : '');
      window.location.href = formAction; 
    }
  }
  
  customElements.define('glasses-finder-form', GlassesFinderForm);
  